import React from 'react';
import QualifyingField from '../QualifyingField';
import SelectField from '../SelectField';

import { QualifyingSelectProps } from './QualifyingSelect.types';

const QualifyingSelect = (props: QualifyingSelectProps): JSX.Element => {
  const { field, form, options, label, onFieldChange, recordDisqualification, disqualificationMessage } = props;
  const isValid =
    form.values[field.name] !== undefined && form.values[field.name] !== '' && form.errors[field.name] !== undefined;
  const errorType = isValid ? undefined : form.errors[field.name];

  return (
    <QualifyingField
      errors={form.errors}
      name={field.name}
      isValid={!isValid}
      marginTopOffset={-3}
      disqualificationMessage={disqualificationMessage}
      recordDisqualification={recordDisqualification}
    >
      <SelectField
        label={label}
        name={field.name}
        field={field}
        form={form}
        options={options}
        error={errorType}
        qualifying={true}
        onFieldChange={onFieldChange}
      />
    </QualifyingField>
  );
};

export { QualifyingSelect as default };
